const CLOUDINARY_CLOUDNAME = 'hbb0rvydd';
const CLOUDINARY_UNSIGNED_UPLOAD_PRESET = 'q6c8hmte';
const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUDNAME}/upload`;

export { CLOUDINARY_CLOUDNAME, CLOUDINARY_URL, CLOUDINARY_UNSIGNED_UPLOAD_PRESET };
